import { z } from 'zod';
/**
 * Wraps an item schema in the envelope every paginated list response uses.
 */
export const paginated = (item) => z.object({
    /**
     * List of items
     */
    list: z.array(item),
    /**
     * Offset from the start of the list
     */
    from: z.number(),
    /**
     * Number of items per page
     */
    limit: z.number(),
    /**
     * Total number of items across all pages
     */
    count: z.number(),
    /**
     * Total number of recorded items
     */
    total: z.number(),
});
//# sourceMappingURL=utils.js.map